var _g, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgDots = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300.000000 300.000000",
    preserveAspectRatio: "xMidYMid ",
    className: "svg",
    style: {
      width: 256,
      height: 256
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,300.000000) scale(0.100000,-0.100000)",
    fill: "#171717",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node1",
    d: "M120 2875 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node2",
    d: "M420 2875 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node3",
    d: "M720 2875 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node4",
    d: "M1020 2875 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node5",
    d: "M1320 2875 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node6",
    d: "M1620 2875 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node7",
    d: "M1920 2875 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node8",
    d: "M2220 2875 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node9",
    d: "M2520 2875 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node10",
    d: "M2820 2875 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node11",
    d: "M120 2575 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node12",
    d: "M420 2575 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node13",
    d: "M720 2575 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node14",
    d: "M1020 2575 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node15",
    d: "M1320 2575 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node16",
    d: "M1620 2575 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node17",
    d: "M1920 2575 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node18",
    d: "M2220 2575 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node19",
    d: "M2520 2575 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node20",
    d: "M2820 2575 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node21",
    d: "M120 2275 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node22",
    d: "M420 2275 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node23",
    d: "M720 2275 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node24",
    d: "M1020 2275 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node25",
    d: "M1320 2275 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node26",
    d: "M1620 2275 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node27",
    d: "M1920 2275 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node28",
    d: "M2220 2275 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node29",
    d: "M2520 2275 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node30",
    d: "M2820 2275 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node31",
    d: "M120 1975 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node32",
    d: "M420 1975 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node33",
    d: "M720 1975 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node34",
    d: "M1020 1975 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node35",
    d: "M1320 1975 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node36",
    d: "M1620 1975 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node37",
    d: "M1920 1975 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node38",
    d: "M2220 1975 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node39",
    d: "M2520 1975 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node40",
    d: "M2820 1975 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node41",
    d: "M120 1675 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node42",
    d: "M420 1675 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node43",
    d: "M720 1675 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node44",
    d: "M1020 1675 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node45",
    d: "M1320 1675 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node46",
    d: "M1620 1675 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node47",
    d: "M1920 1675 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node48",
    d: "M2220 1675 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node49",
    d: "M2520 1675 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node50",
    d: "M2820 1675 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node51",
    d: "M120 1375 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node52",
    d: "M420 1375 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node53",
    d: "M720 1375 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node54",
    d: "M1020 1375 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node55",
    d: "M1320 1375 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node56",
    d: "M1620 1375 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node57",
    d: "M1920 1375 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node58",
    d: "M2220 1375 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node59",
    d: "M2520 1375 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node60",
    d: "M2820 1375 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node61",
    d: "M120 1075 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node62",
    d: "M420 1075 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node63",
    d: "M720 1075 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node64",
    d: "M1020 1075 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node65",
    d: "M1320 1075 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node66",
    d: "M1620 1075 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node67",
    d: "M1920 1075 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node68",
    d: "M2220 1075 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node69",
    d: "M2520 1075 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node70",
    d: "M2820 1075 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node71",
    d: "M120 775 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node72",
    d: "M420 775 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node73",
    d: "M720 775 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node74",
    d: "M1020 775 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node75",
    d: "M1320 775 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node76",
    d: "M1620 775 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node77",
    d: "M1920 775 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node78",
    d: "M2220 775 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node79",
    d: "M2520 775 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node80",
    d: "M2820 775 c-26 -32 13 -81 48 -59 34 22 22 74 -18 74 -10 0 -23 -7 -30 -15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node81",
    d: "M120 475 c-26 -32 13 -81 48 -59 22 14 27 41 12 59 -16 19 -44 19 -60 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node82",
    d: "M420 475 c-26 -32 13 -81 48 -59 22 14 27 41 12 59 -16 19 -44 19 -60 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node83",
    d: "M720 475 c-26 -32 13 -81 48 -59 22 14 27 41 12 59 -16 19 -44 19 -60 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node84",
    d: "M1020 475 c-15 -18 -10 -45 13 -59 34 -22 73 27 47 59 -16 19 -44 19 -60 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node85",
    d: "M1320 475 c-26 -32 13 -81 48 -59 22 14 27 41 12 59 -16 19 -44 19 -60 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node86",
    d: "M1620 475 c-15 -18 -10 -45 13 -59 34 -22 73 27 47 59 -16 19 -44 19 -60 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node87",
    d: "M1920 475 c-26 -32 13 -81 48 -59 22 14 27 41 12 59 -16 19 -44 19 -60 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node88",
    d: "M2220 475 c-26 -32 13 -81 48 -59 22 14 27 41 12 59 -16 19 -44 19 -60 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node89",
    d: "M2520 475 c-26 -32 13 -81 48 -59 22 14 27 41 12 59 -16 19 -44 19 -60 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node90",
    d: "M2820 475 c-15 -18 -10 -45 13 -59 34 -22 73 27 47 59 -16 19 -44 19 -60 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node91",
    d: "M120 175 c-15 -18 -10 -45 13 -59 34 -22 73 27 47 59 -16 19 -44 19 -60 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node92",
    d: "M420 175 c-15 -18 -10 -45 13 -59 34 -22 73 27 47 59 -16 19 -44 19 -60 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node93",
    d: "M720 175 c-15 -18 -10 -45 13 -59 34 -22 73 27 47 59 -16 19 -44 19 -60 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node94",
    d: "M1020 175 c-15 -18 -10 -45 13 -59 34 -22 73 27 47 59 -16 19 -44 19 -60 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node95",
    d: "M1320 175 c-26 -32 13 -81 48 -59 22 14 27 41 12 59 -16 19 -44 19 -60 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node96",
    d: "M1620 175 c-26 -32 13 -81 48 -59 22 14 27 41 12 59 -16 19 -44 19 -60 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node97",
    d: "M1920 175 c-15 -18 -10 -45 13 -59 34 -22 73 27 47 59 -16 19 -44 19 -60 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node98",
    d: "M2220 175 c-26 -32 13 -81 48 -59 22 14 27 41 12 59 -16 19 -44 19 -60 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node99",
    d: "M2520 175 c-26 -32 13 -81 48 -59 9 6 18 19 20 28 8 38 -43 61 -68 31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "node",
    id: "node100",
    d: "M2820 175 c-15 -18 -10 -45 13 -59 34 -22 73 27 47 59 -16 19 -44 19 -60 0z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,300.000000) scale(0.100000,-0.100000)",
    fill: "#A2A2A2",
    stroke: "none"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDots, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/dots.9af1167c.svg";
export { ForwardRef as ReactComponent };